import React, { useEffect, useRef, useState } from 'react'
import User from '../states/User'
import { observer } from "mobx-react-lite"
import MicButton from '../components/Mic'
import CameraButton from '../components/Camera'
import Invite from '../components/Invite'
import MeetingParticipants from "../components/MeetingParticipants"
import { useStore } from '../store'
import { MeetingChat } from '../components/MeetingChat'
import { axiosInstance, getQueryByParameter } from "../const/axiosInstance"
import { MeetingTime } from '../components/MeetingClock'
import Split from "react-split";
import { socket } from "../const/socket";
import SOCKET from "../const/socketNames"
import { useNavigate, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose, faComment, faDesktop, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import PEERConnection from "../utils/WebRTCHandler";
import "./room.css"

const Room = observer(() => {
    const peerInstance = useRef()
    const [currentRoom, setCurrentRoom] = useState({})
    const [displayStream, setDisplayStream] = useState(false)
    const [requestedDate,setRequestedDate] = useState(0)
    const [secretSetted, setSecretSetted] = useState(false)

    const params = useParams()
    const ROOM_ID = params.roomId
    const PURPOSE = getQueryByParameter("purpose")
    const { videoRoomStore, userStore } = useStore()
    const navigate = useNavigate()


    const closeRoomTab = () => {
        window.localStorage.removeItem("existRoom")
    }

    useEffect(() => {
        const date = async () => {
                 const date = await axiosInstance.get("/devices/time")
                 setRequestedDate(Date.now() - new Date(date.data.data))
              }
         date()
     }, [])
 
 
    //  useEffect(() => {
    //      const getTime= async () => {
    //         const date = await axiosInstance.get("/devices/time")
    //         setRequestedDate(date.data.data)
    //      }
    //      const timer = setInterval(getTime, 10000)
    //      if(new Date(currentRoom.start_date ? currentRoom.start_date : currentRoom.created_at) <= new Date(requestedDate)){
    //         clearInterval(timer)
    //      }
    //  }, [])

        const checkDevices = () => {
            // iOS reveals more cameras after getUserMedia permission is granted,
            // so the baseline count changes and triggers a false reload.
            // USB device detection is desktop-only — skip entirely on touch devices.
            if ('ontouchstart' in window) return;

            let initialMics = -1;
            let initialCams = -1;

            const poll = () => {
                navigator.mediaDevices.enumerateDevices().then(devices => {
                    const mics = devices.filter(d => d.kind === 'audioinput').length;
                    const cams = devices.filter(d => d.kind === 'videoinput').length;

                    if (initialMics === -1) {
                        initialMics = mics;
                        initialCams = cams;
                        setTimeout(poll, 5000);
                        return;
                    }

                    if (mics > initialMics || cams > initialCams) {
                        window.location.reload();
                        return;
                    }

                    setTimeout(poll, 5000);
                });
            };
            poll();
        }



    useEffect(() => {  
        checkDevices()
        if(!secretSetted && currentRoom.username){
            if(PURPOSE === "Group" && userStore.username === currentRoom.username){
                 axiosInstance.get(`/devices/setSecret/${ROOM_ID}`)
                 setSecretSetted(true)
            }
        }
    }, [currentRoom.username])

    useEffect(() => {
        window.addEventListener("beforeunload", closeRoomTab)
        return () => {
            window.removeEventListener("beforeunload", closeRoomTab)
            peerInstance.current?.destroyConnection();
        }
    }, []);

    useEffect(() => {
        const hasRoom = localStorage.getItem("existRoom")
        if (User.username && !hasRoom) {
            peerInstance.current = new PEERConnection({
                userDetails: {
                    username: User.username,
                    updateInstance: updateFromInstance
                }, roomId: ROOM_ID
            })
            localStorage.setItem("existRoom", true)
        } else {
            navigate("/home")
        }
        videoRoomStore.getVideoRoomByRoomId(ROOM_ID, PURPOSE).then(res => setCurrentRoom(res))
        if(PURPOSE === "Group"){
            videoRoomStore.getMeetingAllParticiapantsById(ROOM_ID)
        }
        return () => {
            localStorage.removeItem("existRoom")
            userStore.setIsBusy(false)
        }
    }, [])

    const updateFromInstance = (key, value) => {
        if (key === 'displayStream') setDisplayStream(value);
    }
    useEffect(() => {
        if (Object.keys(currentRoom).length && PURPOSE === "Group") {
            if (["approved", "declined"].includes(currentRoom.status)) {
                navigate("/home")
                return
            }
            if (userStore.role !== "Guest" && userStore.username !== currentRoom.username &&
                !currentRoom.invited_users.includes(userStore.username)) {
                navigate("/home")
            }
            if (userStore.role === "Guest" && currentRoom.refused_users.includes(userStore.username)) {
                navigate("/home")
            }
        }
    }, [currentRoom])

    useEffect(() => {
        const showChat = document.querySelector("#showChat");
        const videosGroup = document.querySelector(".videos__group");
        // Chat starts open by default (.main__right has no inline display
        // override yet), so the video grid needs its width cap from the start.
        videosGroup.classList.add("chat-open");
        showChat.addEventListener("click", () => {
            if (document.querySelector(".main__right").style.display === 'none') {
                document.querySelector(".main__right").style.display = "flex";
                document.querySelector(".main__left").style.display = "flex";
                videosGroup.classList.add("chat-open");
            } else {
                document.querySelector(".main__left").style.display = "flex";
                document.querySelector(".main__right").style.display = "none"
                document.querySelector(".main__left").style.flex = "1";
                videosGroup.classList.remove("chat-open");
            }
        });
    }, [])

    useEffect(() => {
        const handleCameraState = ({username, cameraOn}) => {
            const usernameTags = document.querySelectorAll('.video__main-username');
            for (const tag of usernameTags) {
                if (tag.textContent !== username) continue;
                const container = tag.parentElement;
                const existing = container.querySelector('.camera-off-overlay');
                if (!cameraOn && !existing) {
                    const initials = username.slice(0, 2).toUpperCase();
                    const overlay = document.createElement('div');
                    overlay.className = 'camera-off-overlay';
                    overlay.style.cssText = 'position:absolute;inset:0;background:#000;display:flex;align-items:center;justify-content:center;z-index:10';
                    const circle = document.createElement('div');
                    circle.style.cssText = 'width:64px;height:64px;border-radius:50%;background:#4f46e5;display:flex;align-items:center;justify-content:center;font-size:22px;font-weight:700;color:#fff';
                    circle.textContent = initials;
                    overlay.appendChild(circle);
                    container.style.position = 'relative';
                    container.insertBefore(overlay, container.firstChild);
                } else if (cameraOn && existing) {
                    existing.remove();
                }
                break;
            }
        };
        socket.on(SOCKET.MEETING_CAMERA_STATE, handleCameraState);
        return () => socket.off(SOCKET.MEETING_CAMERA_STATE, handleCameraState);
    }, []);

    const handleLeaveCall = () => {
        if (User.username === currentRoom.username) {
            videoRoomStore.finishedMeeting(ROOM_ID)

        }
        if (User.role === "Guest") {
            window.localStorage.removeItem("username")
        }
        socket.emit(SOCKET.MEETING_USER_DISCONNECT, PURPOSE, User.username)
        peerInstance.current.destroyConnection()
        if(window.innerWidth < 700){
            window.location = "/home"
        }else{
            window.close()
        }
    }

    const toggleScreenShare = () => {
        const { reInitializeStream } = peerInstance.current;
        reInitializeStream(false, true, !displayStream ? 'displayMedia' : 'userMedia').then(() => {
            setDisplayStream(!displayStream);
        });
    }


    return (
        <>
            <div className="header flex justify-between">
                <div className="room-name-time">
                    <h3 className="" style={{"font-weight":"bold"}}>{currentRoom.name}</h3>
                    <MeetingTime
                        start_date={currentRoom.start_date ? currentRoom.start_date : currentRoom.created_at} requestedDate={requestedDate}/>
                </div>
                <div></div>
            </div>
            <Split className="main conf-body" sizes={[70, 30]} minSize={[1000, 350]}>
                <div className="main__left">
                    <div className="videos__group">
                        <div id="video-grid"></div>
                    </div>
                    <div className="options conf-footer">
                        <div className="room-options-bar">
                            {
                                <CameraButton peerInstance={peerInstance.current} socket={socket} roomId={ROOM_ID} />
                            }
                            {
                                <MicButton peerInstance={peerInstance.current} />
                            }
                            <div id="showChat" className="options__button">
                                 <img src="/Iconconferancems.png"/>
                            </div>
                            {
                                PURPOSE === "Group" &&
                                <MeetingParticipants room={currentRoom}/>
                            }
                            {PURPOSE === "Group" && userStore.username === currentRoom.username && <div className="options__button">
                                <Invite secretSetted={secretSetted}/>
                            </div>}
                            <div className="options__button">
                                {
                                    <img src="/Iconscreen.png" onClick={toggleScreenShare} />

                                }
                            </div>
                            <div
                                className="options__button"
                                onClick={() => handleLeaveCall()}
                            >
                               <img src='/holdconf.png'/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="main__right conf-chat">
                    <MeetingChat room_id={ROOM_ID} />
                </div>
            </Split>
        </>
    )
}
)

export default Room;
